<template>

    <div class="app-browse-collections ml-2">
        <div class="row pb-3 mt-3 border-bottom border-light">
            <div class="col text-left">
                <router-link to="/browse">
                    All Collections
                </router-link>
                &nbsp;<span class="text-muted">&gt;</span>&nbsp;
                <span class="text-muted">{{categoryName}}</span>
            </div>
        </div>
        <div class="row mt-4 pb-3">
            <div class="col text-left">
                <h3 class="mb-0">Category: <strong>{{categoryName}}</strong></h3>
                <div class="text-muted">{{totalCollections}} Collections</div>

                <!-- <div class="text-muted">Browse all {{totalCollections}} collections and {{totalGradients}} unique gradients</div> -->
            </div>
        </div>
        <collection-list collectionType="CATEGORY" :cat="cat"/>
    </div>

</template>

<script>
import categories from '@/util/categories.js'
import collections from '@/util/collections.js'
import CollectionList from '@/components/CollectionList.vue'

export default {
    components: {
        CollectionList
    },
    metaInfo(){
      return {
        title: `Category: ${this.categoryName} | Gradient Magic`,
        meta: [
            { 
                vmid:'description', name: 'description', 
                content: `CSS Gradient collections in the ${this.categoryName} category.` 
            }
        ],
        link: [
            { vmid: 'canonical', rel: 'canonical', href: `https://www.gradientmagic.com/category/${this.cat}` }
        ]
      }
    },
    props: {
        cat: {
            type: String,
            required: true
        }
    },
    computed: {
        categoryName(){
            for(let i=0;i<categories.length;i++){
                if(categories[i].id === this.cat) return categories[i].name;
            }
            return "UNKNOWN"
        },
        totalCollections(){
            return collections.filter((obj) => {
                return obj.categories.includes(this.cat); 
            }).length
        }
    }
}
</script>